export const FLIGHT_SESSION_EXPIRES_AT_KEY = 'flight_session_expires_at';
export const FLIGHT_SESSION_ALLOWED_EXPIRES_AT_KEY = 'flight_session_allowed_expires_at';
export const FLIGHT_SEARCH_TIMESTAMP_KEY = 'flight_search_timestamp';
